import { Modal } from '@/ui/Modal'
import styles from './LogoutModal.module.scss'
import { Button } from '@/ui/Button'
import { useModal } from '@/components/Modal'
import { useUserLogout } from '../../api/useUserLogout'

export const LogoutModal = () => {
    const { closeModal } = useModal()
    const { mutate: handleUserLogout, isPending } = useUserLogout()

    const handleLogout = () => {
        handleUserLogout()
    }

    return (
        <Modal className={styles.modal} onClose={closeModal} hideCloseButton>
            <div className={styles.information}>
                <h1 className={styles.title}>Log out?</h1>
                <p className={styles.description}>Are you sure you want to log out?</p>
            </div>
            <div className={styles.footer}>
                <Button rounded variant="tertiary" disabled={isPending} onClick={closeModal}>
                    Cancel
                </Button>
                <Button rounded variant="secondary" disabled={isPending} onClick={handleLogout}>
                    Log out
                </Button>
            </div>
        </Modal>
    )
}
